"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = exports.Password = exports.ID = exports.BooleanString = void 0;
const mongoose_1 = __importDefault(require("mongoose"));
const runtypes_1 = require("runtypes");
const validateEmail = (email) => {
    return email
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null || "invalid email";
};
exports.BooleanString = runtypes_1.String.withConstraint((val) => val === "true" || val === "false");
exports.ID = runtypes_1.String.withConstraint(mongoose_1.default.isValidObjectId);
exports.Password = runtypes_1.String.withConstraint((val) => val.length >= 6 || "password must be 6 characters or more");
exports.Email = runtypes_1.String.withConstraint(validateEmail, {
    name: "email",
});
